import React from "react";
import { Button, Tooltip } from "@mantine/core";

import { RedoIcon, UndoIcon } from "@piqnt/runtime-core/react/Icon";

import {
  useMiddleware,
  EmitFunction,
} from "@piqnt/runtime-core/react/ReactMount";
import { SpaceContext } from "../space";

interface HistoryControlComponentProps {
  emit: EmitFunction;
  editable: boolean;
  hasUndo: boolean;
  hasRedo: boolean;
}

const HistoryControlComponent = React.memo(
  (props: HistoryControlComponentProps) => {
    const { editable, emit, hasUndo, hasRedo } = props;

    const onClickUndo = React.useCallback(() => {
      emit("scene-undo");
    }, [emit]);

    const onClickRedo = React.useCallback(() => {
      emit("scene-redo");
    }, [emit]);

    return (
      <Button.Group>
        <Tooltip label="Undo" position="bottom-start">
          <Button
            onClick={onClickUndo}
            title="Undo"
            variant="toolbar"
            disabled={!hasUndo || !editable}
          >
            <UndoIcon />
          </Button>
        </Tooltip>
        <Tooltip label="Redo" position="bottom-start">
          <Button
            onClick={onClickRedo}
            title="Redo"
            variant="toolbar"
            disabled={!hasRedo || !editable}
          >
            <RedoIcon />
          </Button>
        </Tooltip>
      </Button.Group>
    );
  },
);

export const HistoryControl = () => {
  const { context, emit } = useMiddleware<SpaceContext>();

  return (
    <HistoryControlComponent
      editable={context.editable.value}
      hasUndo={context.hasUndo.value}
      hasRedo={context.hasRedo.value}
      emit={emit}
    />
  );
};
